export default function (val, level = 3) {
  let remind = Math.floor(val / 1000)
  const results = []
  while (level >= 1) {
    const unit = Math.pow(60, level - 1)
    const currentTime = Math.floor(remind / unit)
    results.push(currentTime < 10 ? `0${currentTime}` : `${currentTime}`)
    remind = remind % unit
    level--
  }
  return results.join(':')
}
